<div class="info-accordion position-relative" id="{{type}}">

  <!--  TITRE  -->
  <h3 class="pt-4 pb-2 mb-0">
      <span *ngIf="type === 'otherRooms'"
        class="subtitle_1 txt-darkGray">{{ "PROCESSES.ACCOMMODATION.LIST.OTHER_ROOMS" | translate }}</span>
    <span *ngIf="type === 'similarRooms'"
      class="subtitle_1 txt-darkGray">{{ 'PROCESSES.ACCOMMODATION.LIST.INTERESTED_OFFERS' | translate }}</span>
  </h3>


  <div class="d-flex overflow-auto hidden-scrollbar pt-2 pb-3" [ngClass]="'item_box_'+type">
    <!--  BOUTONS  -->
    <ng-container *ngIf="showButtons && (!isMobile || type !== 'similarRooms')">
      <div class="d-flex align-items-center align-content-center">
        <button
          (click)="scrollToPrevious()"
          class="btn btn-prev border-0 rounded-circle text-white p-0 lh-1 d-flex align-items-center justify-content-center aspect-ratio_1-1 btn-scroll">
          <span class="material-icons-outlined font-14">arrow_back_ios</span>
        </button>

        <button
          (click)="scrollToNext()"
          class="btn btn-next border-0 rounded-circle text-white p-0 lh-1 d-flex align-items-center justify-content-center aspect-ratio_1-1 btn-scroll">
          <span class="material-icons-outlined font-14">arrow_forward_ios</span>
        </button>
      </div>
    </ng-container>

    <!--   LOADER     -->
    <div class="w-100 h-100 d-flex align-items-center justify-content-center mb-5" *ngIf="isLoading">
      <div class="spinner-border text-primary"></div>
    </div>

    <!--  ROOMS  -->
    <app-accommodation-room-card *ngFor="let room of otherRooms;let index = index;trackBy:propertyTrackBy"
      (click)="goTo(room)"
      [favList]="favList"
      [isSlider]="true"
      [showPhotoSlider]="type !== 'otherRooms'"
      [room]="room"
      [ngClass]="{'me-3': index !== (otherRooms.length -1)}"
      [typeCard]="'similarRoomsCard'"
      class="flex-shrink-0"></app-accommodation-room-card>
  </div>

</div>
